/**
 * Getting Around tab configuration — provides only the hero image and source text.
 * All other data (transit score, durations, banner, fact rows) is derived from
 * live backend data inside GettingAroundTab.tsx.
 */

import { GettingAroundData } from "../types";
import { withHeroImageParams } from "../utils/neighbourhoodHelpers";
import config from "@Config/index";

const gettingAroundImg = withHeroImageParams(
  `${config.IMAGE_STATIC_URL}/neighbourhood-assets/getting-around.png`,
);

const GETTING_AROUND_DATA: GettingAroundData = Object.freeze({
  heroImage: gettingAroundImg,
  transitScore: "",
  scoreLabel: "Transit Score",
  destination: "",
  transportModes: Object.freeze([]) as unknown as GettingAroundData["transportModes"],
  facts: Object.freeze([]) as unknown as GettingAroundData["facts"],
  source: "Numbeo & OpenStreetMap data",
});

export default GETTING_AROUND_DATA;
